var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 51,
    viewBox: "0 0 39 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2672 1H1.73285C1.32802 1 1 1.32136 1 1.71775V35.8117C1 36.208 1.32802 36.5294 1.73285 36.5294C2.13767 36.5294 2.46569 36.208 2.46569 35.8117V2.43549H36.5343V6.94773C36.5343 7.34411 36.8623 7.66547 37.2672 7.66547C37.672 7.66547 38 7.34411 38 6.94773V1.71775C38 1.32136 37.672 1 37.2672 1V1Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2672 9.5813C36.8623 9.5813 36.5343 9.90266 36.5343 10.299V48.5645H2.46569V39.163C2.46569 38.7666 2.13767 38.4452 1.73285 38.4452C1.32802 38.4452 1 38.7666 1 39.163V49.2822C1 49.6786 1.32802 50 1.73285 50H37.2672C37.672 50 38 49.6786 38 49.2822V10.299C38 9.90266 37.672 9.5813 37.2672 9.5813Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15869 15.9271C4.15869 18.9881 6.70138 21.4784 9.82683 21.4784C12.9523 21.4784 15.495 18.9881 15.495 15.9271C15.495 12.866 12.9523 10.3757 9.82683 10.3757C6.70138 10.3757 4.15869 12.866 4.15869 15.9271ZM9.82683 20.0429C7.50956 20.0429 5.62439 18.1966 5.62439 15.9271C5.62439 13.9025 7.12506 12.2158 9.09398 11.8752V15.9271C9.09398 16.3235 9.422 16.6448 9.82683 16.6448H13.964C13.616 18.5732 11.894 20.0429 9.82683 20.0429ZM13.964 15.2093H10.5597V11.8752C12.2904 12.1747 13.6582 13.5143 13.964 15.2093Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28619 42.3752C4.88137 42.3752 4.55334 42.6966 4.55334 43.093V46.1865C4.55334 46.5829 4.88137 46.9042 5.28619 46.9042H10.0241C10.4289 46.9042 10.7569 46.5829 10.7569 46.1865V43.093C10.7569 42.6966 10.4289 42.3752 10.0241 42.3752H5.28619ZM9.29125 45.4687H6.01904V43.8107H9.29125V45.4687Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1827 46.9031H17.9205C18.3253 46.9031 18.6533 46.5818 18.6533 46.1854V38.4516C18.6533 38.0552 18.3253 37.7339 17.9205 37.7339H13.1827C12.7779 37.7339 12.4498 38.0552 12.4498 38.4516V46.1854C12.4498 46.5818 12.7779 46.9031 13.1827 46.9031ZM13.9155 39.1694H17.1876V45.4677H13.9155V39.1694Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0795 31.9343C20.6747 31.9343 20.3467 32.2557 20.3467 32.6521V46.1862C20.3467 46.5826 20.6747 46.9039 21.0795 46.9039H25.8173C26.2222 46.9039 26.5502 46.5826 26.5502 46.1862V32.6521C26.5502 32.2557 26.2222 31.9343 25.8173 31.9343H21.0795ZM25.0845 45.4684H21.8124V33.3698H25.0845V45.4684Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7133 32.0378C34.1181 32.0378 34.4461 31.7164 34.4461 31.32V28.7888C34.4461 28.3924 34.1181 28.071 33.7133 28.071H28.9761C28.5713 28.071 28.2433 28.3924 28.2433 28.7888V46.1889C28.2433 46.5853 28.5713 46.9066 28.9761 46.9066H33.7132C34.118 46.9066 34.446 46.5853 34.446 46.1889V34.6695C34.446 34.2731 34.118 33.9518 33.7132 33.9518C33.3083 33.9518 32.9803 34.2731 32.9803 34.6695V45.4711H29.709V29.5065H32.9803V31.32C32.9804 31.7164 33.3084 32.0378 33.7133 32.0378Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3964 4.09448H11.6035C11.1986 4.09448 10.8706 4.41584 10.8706 4.81223V7.90572C10.8706 8.3021 11.1986 8.62346 11.6035 8.62346H27.3965C27.8013 8.62346 28.1294 8.3021 28.1294 7.90572V4.81223C28.1293 4.41584 27.8012 4.09448 27.3964 4.09448ZM26.6636 7.18797H12.3363V5.52998H26.6637V7.18797H26.6636Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1084 10.3757H19.4999C19.0951 10.3757 18.7671 10.6971 18.7671 11.0935C18.7671 11.4899 19.0951 11.8112 19.4999 11.8112H34.1084C34.5132 11.8112 34.8413 11.4899 34.8413 11.0935C34.8413 10.6971 34.5131 10.3757 34.1084 10.3757Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1084 13.5977H19.4999C19.0951 13.5977 18.7671 13.919 18.7671 14.3154C18.7671 14.7118 19.0951 15.0331 19.4999 15.0331H34.1084C34.5132 15.0331 34.8413 14.7118 34.8413 14.3154C34.8413 13.919 34.5131 13.5977 34.1084 13.5977Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8413 17.5405C34.8413 17.1441 34.5132 16.8228 34.1084 16.8228H19.4999C19.0951 16.8228 18.7671 17.1441 18.7671 17.5405C18.7671 17.9369 19.0951 18.2582 19.4999 18.2582H34.1084C34.5131 18.2582 34.8413 17.9369 34.8413 17.5405Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.919 20.7624C28.919 20.366 28.591 20.0447 28.1861 20.0447H19.4999C19.0951 20.0447 18.7671 20.366 18.7671 20.7624C18.7671 21.1588 19.0951 21.4802 19.4999 21.4802H28.1861C28.5909 21.4802 28.919 21.1588 28.919 20.7624Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4998 24.782H6.1745C5.76967 24.782 5.44165 25.1033 5.44165 25.4997C5.44165 25.8961 5.76967 26.2175 6.1745 26.2175H19.4998C19.9046 26.2175 20.2327 25.8961 20.2327 25.4997C20.2327 25.1033 19.9046 24.782 19.4998 24.782Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2327 28.7217C20.2327 28.3253 19.9046 28.0039 19.4998 28.0039H6.1745C5.76967 28.0039 5.44165 28.3253 5.44165 28.7217C5.44165 29.118 5.76967 29.4394 6.1745 29.4394H19.4998C19.9046 29.4394 20.2327 29.118 20.2327 28.7217Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3104 31.9438C14.3104 31.5474 13.9824 31.2261 13.5775 31.2261H6.1745C5.76967 31.2261 5.44165 31.5474 5.44165 31.9438C5.44165 32.3402 5.76967 32.6616 6.1745 32.6616H13.5775C13.9823 32.6616 14.3104 32.3402 14.3104 31.9438Z",
    fill: "#FF0099",
    stroke: "#FF0099",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.91e07490fef7bef3d26885739369abff.svg";
export { ForwardRef as ReactComponent };